module.exports = __webpack_public_path__ + "static/media/ka-rotate.fd6dd225.mp4";